import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'levelText',
})
export class LevelTextPipe implements PipeTransform {
  transform(value: number | string): string {
    if (typeof value === 'string') {
      value = parseInt(value, 10);
    }

    switch (value) {
      case 1:
        return 'Chase';
      case 2:
        return 'Find';
      case 3:
        return 'Visit'
      default:
        return '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/level-text.pipe.ts